import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { motion, AnimatePresence } from 'framer-motion';
import mockup from '../../Assets/MOCKUPS_2.png';
import * as S from './Contact.style';

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.15 },
  },
};

const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0 },
};

export const Contact = () => {
  const { register, handleSubmit, reset } = useForm();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const onSubmit = async (data) => {
    const payload = {
      de: 'no-reply@bindflow.com.br',
      para: 'contato@bindflow.com.br',
      assunto: 'Contato pelo site Bindtrack',
      corpo: `Nome: ${data?.name} <br />Telefone: ${data?.phone} <br />`,
    };

    setLoading(true);
    setSuccess(false);

    try {
      const response = await fetch(
        'https://functions-delivery.azurewebsites.net/api/Enviar?code=3JuuSqixm_yWDiQltHigzCpdWhFfHi-5YF4sDKvkCxaJAzFuwEu9CA%3D%3D',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }
      );

      const text = await response.text();
      if (response.ok) {
        setSuccess(true);
        reset();
      } else {
        throw new Error(text);
      }
    } catch (error) {
      console.error('Erro ao enviar:', error);
      alert('Erro ao enviar: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <S.Wrapper>
      <S.ContentBox  >
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="w-full md:min-w-[467px] md:w-[50%] "
        >
          <S.Title as={motion.h1} variants={item}>
            pronto para revolucionar a sua logística?
          </S.Title>

          <S.SubTitle as={motion.p} variants={item}>
            Entre em contato e solicite um diagnóstico inicial gratuito.
          </S.SubTitle>

          <S.Form
            onSubmit={handleSubmit(onSubmit)}
          >
            <motion.div variants={item}>
              <S.Input
                type="text"
                placeholder="Nome"
                {...register('name', { required: true })}
              />
            </motion.div>

            <motion.div variants={item}>
              <S.Input
                type="tel"
                placeholder="Telefone"
                {...register('phone', { required: true })}
              />
            </motion.div>

            <motion.div variants={item}>
              <S.Btn
                type="submit"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                disabled={loading}
              >
                {loading ? 'Enviando...' : 'ENVIAR'}
              </S.Btn>
            </motion.div>
          </S.Form>

          <AnimatePresence>
            {success && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.4 }}
                className="mt-4 text-green-700 bg-green-100 p-3 rounded"
              >
                Mensagem enviada com sucesso!
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>

        <motion.img
          src={mockup}
          alt="mockup"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="hidden md:block w-full sm:h-[332px] sm:min-h-[332px] sm:w-[498px] sm:min-w-[498px]  mt-10 md:mt-0 sm:-mr-[350px] md:-mr-[250px] lg:-mr-[120px] xl:mr-0 lg:h-[532px] lg:min-h-[532px] lg:w-[698px] lg:min-w-[698px]"
        />
      </S.ContentBox>
    </S.Wrapper>

  );
};
